import * as actionTypes from './actionTypes';

import { createActionObject, getNoArgDispatcherFunc } from '../../helpers/common';

import * as strings from '../../helpers/strings';

export const setName = name => dispatch => dispatch(
  createActionObject(
    actionTypes.SET_NAME,
    { 
      name,
      nameError: name ? "" : strings.msgNameRequired
    }
  )
);

export const setEmail = email => dispatch => dispatch(
  createActionObject(
    actionTypes.SET_EMAIL,
    { 
      email,
      emailError: email ? "" : strings.msgEmailRequired
    }
  )
)


export const setCompany = company => dispatch => dispatch(
  createActionObject(
    actionTypes.SET_COMPANY,
    { 
      company,
      companyError: company ? "" : strings.msgCompanyRequired
    }
  )
)

export const setPhone = phone => dispatch => dispatch(
  createActionObject(
    actionTypes.SET_PHONE,
    { phone }
  )
)

export const setMobile = mobile => dispatch => dispatch(
  createActionObject(
    actionTypes.SET_MOBILE,
    { 
      mobile,
      mobileError: mobile ? "" : strings.msgMobileRequired
    }
  )
)

export const setPassword = password => dispatch => dispatch(
  createActionObject(
    actionTypes.SET_PASSWORD,
    { 
      password,
      passwordError: password ? "" : strings.msgPasswordRequired
    }
  )
)

export const setPersonaId = personaId => dispatch => dispatch(
  createActionObject(
    actionTypes.SET_PERSONA_ID,
    { personaId }
  )
)

export const setRole = role => dispatch => dispatch(
  createActionObject(
    actionTypes.SET_ROLE,
    { role }
  )
)

export const setSubClient = parentId => dispatch => dispatch(
  createActionObject(
    actionTypes.SET_SUB_CLIENT,
    { parentId }
  )
)

export const setMaxSessionCompany = maxSessionCompany => dispatch => dispatch(
  createActionObject(
    actionTypes.SET_MAX_SESSION_COMPANY,
    { 
      maxSessionCompany,
      maxSessionCompanyError: (maxSessionCompany > 0) ? "" : strings.msgMaxSessionCompanyRequired,
    }
  )
)

export const setMaxSessionClient = maxSessionClient => dispatch => dispatch(
  createActionObject(
    actionTypes.SET_MAX_SESSION_CLIENT,
    { 
      maxSessionClient,
      maxSessionClientError: (maxSessionClient > 0) ? "" : strings.msgMaxSessionClientRequired,
    }
  )
)

export const toggleDeleteConfirm = getNoArgDispatcherFunc(actionTypes.TOGGLE_DELETE_CONFIRM);

export const toggleStationsDialog = getNoArgDispatcherFunc(actionTypes.TOGGLE_STATIONS_DIALOG)

export const closeSnackBar = getNoArgDispatcherFunc(actionTypes.CLOSE_SNACK_BAR);

export const resetActionStatus = getNoArgDispatcherFunc(actionTypes.RESET_ACTION_STATUS);